import * as React from 'react';
import { useParams } from 'react-router-dom';

import BasePane from '@totem/components/BasePane';
import ScoringSection from '@totem/components/surveyV2/instanceDetail/score/ScoringSection';
import SurveyInstanceContainer from '@totem/components/surveyV2/instanceDetail/SurveyInstanceContainer';
import CardBody from '@totem/components/ui_components/cards/CardBody';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';
const ScoringPage = () => {
  const { id } = useParams();

  return (
    <ContentLayout>
      <SurveyInstanceContainer surveyInstanceId={id}>
        <BasePane>
          <PrimaryContentPane>
            <CardBody>
              <ScoringSection />
            </CardBody>
          </PrimaryContentPane>
        </BasePane>
      </SurveyInstanceContainer>
    </ContentLayout>
  );
};

export default ScoringPage;
